"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
function throttle(fn, limit) {
  var _this = this;

  var waiting = false;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!waiting) {
      fn.apply(_this, args);
      waiting = true;
      setTimeout(function () {
        waiting = false;
      }, limit);
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./_js/throttle.js
// module id = 22
// module chunks = 0